//faq模块
document.addEventListener('DOMContentLoaded', function() {
    const productFaqItems = Array.from(document.querySelectorAll(".product-faq-como-box .product-faq-item"));

    if(!productFaqItems || productFaqItems.length === 0){return;}
   
    productFaqItems.forEach((item, index) => {
        const clickImg = item.querySelector(".product-faq-img");
        const opentext = item.querySelector(".product-faq-item-bottom");

        if(!clickImg || !opentext){return;}

        clickImg.addEventListener("click", () => {
            // 检查当前项是否已经激活
            const isActive = opentext.classList.contains('active');
            
            // 先关闭所有其他项
            productFaqItems.forEach((otherItem, otherIndex) => {
                if(otherIndex !== index) {
                    const otherImg = otherItem.querySelector(".product-faq-img");
                    const otherText = otherItem.querySelector(".product-faq-item-bottom");
                    
                    if(otherImg && otherText) {
                        otherImg.classList.remove('active'); // 移除激活类
                        otherText.classList.remove('active');
                    }
                }
            });
            
            // 切换当前项的状态
            if(isActive) {
                // 如果当前项是激活的，则关闭它
                clickImg.classList.remove('active');
                opentext.classList.remove('active');
            } else {
                // 如果当前项未激活，则激活它
                clickImg.classList.add('active');
                opentext.classList.add('active');
            }
        });
    });
})


//画廊，左右切换
document.addEventListener('DOMContentLoaded', function() {
  
    const currentDisplayNumElement=document.querySelector(".current-slider-counter-como");

    const currentMobileDisplayNumElement=document.querySelector(".slider-counter-mb-wrapper .slider-counter-mb-wrapper-current");

    const mainProductMediaContainer = document.querySelector(".main-product-media-como-container");
    const mainProductMediaItems = Array.from(document.querySelectorAll(".main-product-media-como-item"));
    const mainProductMediaItemsLength = mainProductMediaItems.length;

    const thumbnailWrapper = document.querySelector(".Thumbnails-bottom-button-como-wrapper");
    const thumbnailItems = Array.from(document.querySelectorAll(".thumbnail-list-item-como"));

    const preButton = document.querySelector(".button-como-wrapper .button-prev-como");
    const nextButton = document.querySelector(".button-como-wrapper .button-next-como");

    if (!mainProductMediaContainer || mainProductMediaItems.length == 0 || !thumbnailWrapper || thumbnailItems.length == 0 || !preButton || !nextButton) {
        return;
    }

    thumbnailItems.forEach((item)=>{
        item.addEventListener("click",(e)=>{
            let currentValue=e.target.parentElement.dataset.mediaPosition;
            console.log("e.target.----como",e.target.parentElement.dataset.mediaPosition);

             if(currentDisplayNumElement&&currentMobileDisplayNumElement){

                  currentDisplayNumElement.textContent=`${currentValue}`;
                 currentMobileDisplayNumElement.textContent=`${currentValue}`;
          }
        })

       
    })

 
    preButton.addEventListener("click", () => {
        // console.log("点击preButton");
        const currentMainProductMedia = document.querySelector(".main-product-media-como-item.is-active");
        const currentMainProductMediaValue = currentMainProductMedia.dataset.mainProductIndex;

        if (currentMainProductMediaValue == 1) {
            // console.log("点击preButton------返回");
            return;
        }

        const preElementNumValue = parseInt(currentMainProductMediaValue) - 1;

        // 找到前一个 thumbnail item
        const previousThumbnailItem = thumbnailItems[preElementNumValue - 1];
        if (previousThumbnailItem) {
            // 点击它内部的按钮
            const buttonToClick = previousThumbnailItem.querySelector('button');
            if (buttonToClick) {
                buttonToClick.click();
            }
        }

        //    console.log("currentCounterElement---currentDisplayNumElement---prev",currentCounterElement,currentDisplayNumElement);
          const currentCounterElement=document.querySelector(".main-product-media-como-item.is-active");
            if(currentCounterElement && currentDisplayNumElement &&currentMobileDisplayNumElement){
            let currentValue = currentCounterElement.dataset.mainProductIndex;
            // console.log("currentValue-----Como----prev",currentValue);
                currentDisplayNumElement.textContent=`${currentValue}`;
                currentMobileDisplayNumElement.textContent=`${currentValue}`;
            }

    });

    nextButton.addEventListener("click", () => {
        // console.log("点击nextButton");
        let currentMainProductMedia = document.querySelector(".main-product-media-como-item.is-active");
        let currentMainProductMediaValue = currentMainProductMedia.dataset.mainProductIndex;

        if (currentMainProductMediaValue == mainProductMediaItemsLength) {
            // console.log("点击nextButton-----返回");
            return;
        }

        const nextElementNumValue = parseInt(currentMainProductMediaValue) + 1;

        // 找到下一个 thumbnail item
        const nextThumbnailItem = thumbnailItems[nextElementNumValue - 1];
        if (nextThumbnailItem) {
            // 点击它内部的按钮
            const buttonToClick = nextThumbnailItem.querySelector('button');
            if (buttonToClick) {
                buttonToClick.click();
            }
        }

        //  console.log("currentCounterElement---currentDisplayNumElement--next",currentCounterElement,currentDisplayNumElement);
          const currentCounterElement=document.querySelector(".main-product-media-como-item.is-active");
            if(currentCounterElement && currentDisplayNumElement&&currentMobileDisplayNumElement){
            let currentValue = currentCounterElement.dataset.mainProductIndex;
            // console.log("currentValue-----Como--next",currentValue);
                currentDisplayNumElement.textContent=`${currentValue}`;
                 currentMobileDisplayNumElement.textContent=`${currentValue}`;
            }
    });

   
   
});

//右侧底部的may also like左右切换
document.addEventListener('DOMContentLoaded', function() {
    
})